export let TileLayerType;

(function (TileLayerType) {
  TileLayerType[TileLayerType["Ground"] = 0] = "Ground";
  TileLayerType[TileLayerType["Decoration"] = 1] = "Decoration";
})(TileLayerType || (TileLayerType = {}));